import { emptyObj } from 'util/objects'
import selectBase from './selectBase'

export const selectCurrentUser = state => selectBase(state) || emptyObj
